module.exports = __webpack_public_path__ + "img/6.894918d1.png";